import { render, staticRenderFns } from "./MyAds.vue?vue&type=template&id=08130432&scoped=true&"
import script from "./MyAds.vue?vue&type=script&lang=js&"
export * from "./MyAds.vue?vue&type=script&lang=js&"
import style0 from "./MyAds.vue?vue&type=style&index=0&id=08130432&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08130432",
  null
  
)

export default component.exports